// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-header ion-toolbar {
  --background: #ffffff;
  --border-color: #e7ece8;
  border-bottom: 1px solid #e7ece8;
}

.popup-title-wrap {
  padding: 8px 14px 10px;
}

.popup-title-wrap h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1f2f26;
}

.popup-title-wrap p {
  margin: 4px 0 0;
  font-size: 12px;
  color: #718479;
}

.popup-content {
  --background: #f5f8f6;
}

.popup-list {
  padding: 10px 10px 14px;
}

.popup-item {
  --background: #fff;
  --border-radius: 12px;
  margin-bottom: 8px;
  border: 1px solid #e4ece7;
  box-shadow: 0 6px 14px rgba(16, 58, 41, 0.06);
}

.popup-item ion-label h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #1f2f26;
}

.popup-item ion-label p {
  margin: 4px 0 0;
  font-size: 12px;
  color: #6f8377;
}

.popup-empty {
  margin: 48px auto 0;
  text-align: center;
  color: #6f8377;
  font-size: 14px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/app/custom popup/savedcreditcardPopUp/savedCreditCardPopup.scss","webpack://./src/app/custom%20popup/savedcreditcardPopUp/savedCreditCardPopup.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,uBAAA;EACA,gCAAA;ACCF;;ADEA;EACE,sBAAA;ACCF;;ADEA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;ACCF;;ADEA;EACE,eAAA;EACA,eAAA;EACA,cAAA;ACCF;;ADEA;EACE,qBAAA;ACCF;;ADEA;EACE,uBAAA;ACCF;;ADEA;EACE,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,6CAAA;ACCF;;ADEA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;ACCF;;ADEA;EACE,eAAA;EACA,eAAA;EACA,cAAA;ACCF;;ADEA;EACE,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;ACCF","sourcesContent":[".popup-header ion-toolbar {\r\n  --background: #ffffff;\r\n  --border-color: #e7ece8;\r\n  border-bottom: 1px solid #e7ece8;\r\n}\r\n\r\n.popup-title-wrap {\r\n  padding: 8px 14px 10px;\r\n}\r\n\r\n.popup-title-wrap h2 {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  color: #1f2f26;\r\n}\r\n\r\n.popup-title-wrap p {\r\n  margin: 4px 0 0;\r\n  font-size: 12px;\r\n  color: #718479;\r\n}\r\n\r\n.popup-content {\r\n  --background: #f5f8f6;\r\n}\r\n\r\n.popup-list {\r\n  padding: 10px 10px 14px;\r\n}\r\n\r\n.popup-item {\r\n  --background: #fff;\r\n  --border-radius: 12px;\r\n  margin-bottom: 8px;\r\n  border: 1px solid #e4ece7;\r\n  box-shadow: 0 6px 14px rgba(16, 58, 41, 0.06);\r\n}\r\n\r\n.popup-item ion-label h3 {\r\n  margin: 0;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  color: #1f2f26;\r\n}\r\n\r\n.popup-item ion-label p {\r\n  margin: 4px 0 0;\r\n  font-size: 12px;\r\n  color: #6f8377;\r\n}\r\n\r\n.popup-empty {\r\n  margin: 48px auto 0;\r\n  text-align: center;\r\n  color: #6f8377;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n}\r\n",".popup-header ion-toolbar {\n  --background: #ffffff;\n  --border-color: #e7ece8;\n  border-bottom: 1px solid #e7ece8;\n}\n\n.popup-title-wrap {\n  padding: 8px 14px 10px;\n}\n\n.popup-title-wrap h2 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: #1f2f26;\n}\n\n.popup-title-wrap p {\n  margin: 4px 0 0;\n  font-size: 12px;\n  color: #718479;\n}\n\n.popup-content {\n  --background: #f5f8f6;\n}\n\n.popup-list {\n  padding: 10px 10px 14px;\n}\n\n.popup-item {\n  --background: #fff;\n  --border-radius: 12px;\n  margin-bottom: 8px;\n  border: 1px solid #e4ece7;\n  box-shadow: 0 6px 14px rgba(16, 58, 41, 0.06);\n}\n\n.popup-item ion-label h3 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #1f2f26;\n}\n\n.popup-item ion-label p {\n  margin: 4px 0 0;\n  font-size: 12px;\n  color: #6f8377;\n}\n\n.popup-empty {\n  margin: 48px auto 0;\n  text-align: center;\n  color: #6f8377;\n  font-size: 14px;\n  font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
